<template>
  <div class="home__performances rounded-2xl" v-if="kpis.length > 0">
    <div class="home__performances__header rounded-t-2xl">
      <strong class="title">Mes indicateurs de performance</strong>
    </div>
    <div class="home__performances__content rounded-b-2xl">
      <section v-for="(kpi, index) in kpis" :key="index">
        <div class="title flex items-center">
          <img :src="kpi.icon.url" class="mr-2" alt="">
          <span>{{ kpi.name }}</span>
        </div>
        <div class="rating flex items-center"
             :style="{ background: kpi.title.backgroundColor }">
          <img src="@/assets/performances/arrow.png" alt="">
          <span :style="{ color: kpi.title.textColor }">{{ kpi.title.text }}</span>
        </div>
        <div class="home__performances__content__bloc p-4">
          <div class="lg:flex lg:items-start">
            <div class="indicator mb-4 mx-auto lg:mr-4 lg:mx-0 lg:mb-0">
              <img :src="kpi.jaugeImg" alt="" class="jauge">
            </div>
            <p>{{ kpi.details }}</p>
          </div>
          <div class="xl:flex xl:items-start">
            <CategoryLayout v-for="(category, catIndex) in kpi.trophyCategories"
                    :key="catIndex"
                    :category="category" />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CategoryLayout from '@/components/Home/KPIS/CategoryLayout.vue'
import { useUserStore } from "@/store/UserStore"

export default {
    name: 'Performances',
    components: {
        CategoryLayout
    },
    data () {
        const UserStore = useUserStore();
        return {
            UserStore: UserStore,
            kpis: {}
        }
    },
    mounted() {
        this.kpis = this.UserStore.kpis;
    }
}
</script>